
<div class="bx-cntnt">
  <span class="">
    <div class="ui-g" style="margin-bottom: 1rem;">
      <div class="ui-g-6 topPadding fontClass">
        <h4 class="textsize" matSubheader>Reporter:</h4>
      </div>
      <div class="ui-g-6 topPadding fontClass">
        <h4 class="textsize" matSubheader>{{this.userService.getActiveMPID()}}</h4>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div>
      <div class="ui-g" style="margin-bottom: 1rem; margin-top: 1rem;">
        <div class="ui-g-6 topPadding fontClass">
          <h4 class="textsize" matSubheader>Report Date:</h4>
        </div>
        <div class="ui-g-6 topPadding fontClass">
          <app-datepicker-calendar [date]="reportDate" [isDateRange]="false" (dateChange)="getDateEmitter($event)"></app-datepicker-calendar>
        </div>
      </div>
      <mat-divider></mat-divider>
      @if(fileProcessingType=='CAT Recon'){

        <div class="ui-g" style="margin-bottom: 1rem; margin-top: 1rem;">
          <div class="ui-g-6 topPadding fontClass">
            <h4 class="textsize" matSubheader>Recon Type:</h4>
          </div>
          <div class="ui-g-6 topPadding fontClass">
            <p-multiSelect id="filterDrpbyTypeMultiSelect" name="filterDrpbyTypeMultiSelect"
                        [options]="reconTypes"
                        optionLabel="key"
                        optionValue="value"
                        [autofocus] = "true"
                        [required]="true"
                        [(ngModel)]="reconvalues" appendTo="body" 
                        [filter]="true" 
                        styleClass = "filter-multiselect"
                        [style]="{ 'text-transform': 'capitalize','overflow':'visible','width':'100%'}"
                        placeholder="Choose" />
          </div>
        </div>
      }

      @if(fileProcessingType=='CAT Exceptions Restore' || fileProcessingType=='Comparative Review'){
      <div>
        @if(isLoadingGroupList){
        <span class="ui-g fontClass" style="text-align:center;">Loading Group list
          <img alt="loader" style="text-align:center"
            src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
          <mat-divider></mat-divider>
        </span>}
        @if(!isLoadingGroupList){
        <div class="ui-g fontClass" style="margin-bottom: 1rem; margin-top: 1rem;">
          <div class="ui-g-6 topPadding">
            <h4 class="textsize" matSubheader>Group Name:</h4>
          </div>
          <div class="ui-g-6 topPadding fontClass">
            <h4 class="textsize" matSubheader>
              @if(fileProcessingType == 'Comparative Review'){
                <p-select id="dropDown" [options]="groupListDropDown" [(ngModel)]="selectedGroup" appendTo="body"
                [style]="{'text-transform': 'capitalize','width':'100%'}" placeholder="Select a Group" filter="true"
                required="true" optionDisabled="inActive">
              </p-select>
              } @else {
              <p-select id="dropDown" [options]="groupListDropDown" [(ngModel)]="selectedGroup" appendTo="body"
                [style]="{'text-transform': 'capitalize','width':'100%'}" placeholder="Select a Group" filter="true"
                required="true">
              </p-select>
              }
            </h4>
          </div>
        </div>}
      </div>}
    </div>

   
    <button id="submit" [disabled]="isLoadingGroupList || isFileProcessingStated" mat-raised-button
      class="defaultBtnColor" icon="fa fa-check" (click)="catScriptCall()" style="color: white; font-family: Roboto, Trebuchet MS, Arial, Helvetica, sans-serif; font-size: 14px;">Submit
      @if(isFileProcessingStated){
      <img style="text-align:center" alt="loader"
      src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
      }</button>
     </span>
</div>